import React, { forwardRef } from 'react';
import Autosuggest from '@stencil/autosuggest';

import * as S from './search-widget-autosuggest.styles';
import * as C from '../SearchWidget/search-widget-ui.styles';

import { EXPLORER_AUTOSUGGEST } from '@stencil/flights-constants/src/urls';
import { AUTOSUGGEST_PLACEHOLDER } from '@stencil/flights-constants/src/text';
import LocationIcon from '@stencil/flights-icons/src/location-icon';
import FlightSuggestIcon from '@stencil/flights-icons/src/flight-suggest-icon';

const SearchWidgetAutosuggest = ({ updateLocation, location, label, isCityCountry = false }) => {
  const getUrl = search_query => {
    if (isCityCountry) {
      return `${EXPLORER_AUTOSUGGEST}?query=${search_query}&limit=10&matchCity=true&matchCountry=true&matchContinent=true`;
    }
    return `${EXPLORER_AUTOSUGGEST}?query=${search_query}&limit=10`;
  };

  const massageData = items => {
    const list = [];
    const len = items.length;
    for (let i = 0; i < len; i++) {
      const item = items[i];
      list.push(item);
      if (item.g) {
        const grps = item.g;
        for (let j = 0; j < grps.length; j++) {
          const grp = grps[j];
          list.push(grp);
        }
      }
    }
    return list;
  };

  const itemToString = item => {
    return item.ct || item.cnty || item.con;
  };

  const itemElement = item => (
    <S.SearchListItem key={item._id}>
      {item.g || item.con === 'ANYWHERE' ? (
        <LocationIcon fill="#0069E2" width="2.5rem" height="2.5rem" loading="lazy" />
      ) : (
        <FlightSuggestIcon width="2.5rem" height="2.5rem" fill="#0069E2" loading="lazy" />
      )}
      <S.SuggstEleContain>
        <S.SuggstEleSubHdWrp>
          <S.SuggstEleHd>
            {item.ct ? item.ct + ', ' : ''} {item.cnty ? item.cnty : item.con}
          </S.SuggstEleHd>
          <S.SuggstEleSubHd>{item.iata ? '(' + item.iata + ')' : ''}</S.SuggstEleSubHd>
        </S.SuggstEleSubHdWrp>
        <S.SuggestEleDesc>{item.n}</S.SuggestEleDesc>
      </S.SuggstEleContain>
    </S.SearchListItem>
  );

  const inputElement = forwardRef((props, ref) => {
    return (
      <S.AutocompleteWrapperStyles>
        <C.SearchLabelStyle>{label}</C.SearchLabelStyle>
        <C.SearchInputStyle {...props} hasValue={true} />
      </S.AutocompleteWrapperStyles>
    );
  });

  const listElement = props => {
    return <S.SearchMenuStyles>{props.children}</S.SearchMenuStyles>;
  };

  const locationVal = location.ct || location.cnty || location.con || location.iata || location;

  if (!locationVal) {
    return (
      <Autosuggest
        key="autosuggest-with-iata"
        placeholder={AUTOSUGGEST_PLACEHOLDER}
        getUrl={getUrl}
        massageData={massageData}
        onItemSelection={updateLocation}
        itemToString={itemToString}
        itemElement={itemElement}
        Input={inputElement}
        initialInputValue={
          location.ct || location.cnty || location.con || location.iata || location
        }
        List={listElement}
        selectTextOnFocus={true}
        isCityCountry={isCityCountry}
      />
    );
  }

  return (
    <Autosuggest
      key="autosuggest-with-name"
      placeholder={AUTOSUGGEST_PLACEHOLDER}
      getUrl={getUrl}
      massageData={massageData}
      onItemSelection={updateLocation}
      itemToString={itemToString}
      itemElement={itemElement}
      Input={inputElement}
      initialInputValue={location.ct || location.cnty || location.con || location.iata || location}
      List={listElement}
      selectTextOnFocus={true}
      isCityCountry={isCityCountry}
    />
  );
};

export default SearchWidgetAutosuggest;
